<template>
	<div class="container">
		
	</div>
</template>
<script>
	export default {
		name: "recivedResult",
		data() {
			return {
				success: require('@/assets/success.png'),
				fail: require('@/assets/fail.png'),
				statu: 1, // 1-成功 2-失败
			}
		},
		created() {
			console.log("this - - -", this.$route);
			this.statu = this.$route.query.statu ? Number(this.$route.query.statu) : 1

			document.title = this.statu == 1 ? '收款成功' : '收款失败';
		}
	}
</script>

<style scoped>
	.container {
		width: 100%;
		height: 96vh;
		box-sizing: border-box;
		margin: 0;
		padding: 0;
		background-color: #FFF;
		z-index: 1;
	}

	.main1 {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 20px 10px;
		margin: 0;
		overflow: hidden;
		z-index: 2;
	}

	.img {
		width: 108px;
		height: 100px;
		box-sizing: border-box;
	}

	.tit {
		color: rgb(0, 0, 0);
		font-family: 思源黑体;
		font-size: 20px;
		font-weight: 400;
		letter-spacing: 0px;
		margin: 14px 0;
	}

	.desc {
		width: 60%;
		height: auto;
		box-sizing: border-box;

		color: rgb(133, 133, 133);
		font-family: 思源黑体;
		font-size: 12px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 18px;
		text-align: center;
	}
</style>